<!-- Filtro avanzado flotante superior -->
<app-advanced-filter #advFilter [fields]="advancedFilterFields" [showTrigger]="false"
    (filtersChange)="activeAdvancedFilters.set($event)">
</app-advanced-filter>

<!-- Cabecera estandarizada responsive -->
<app-page-header
    [title]="pageHeaderTitle()"
    [mobileTitle]="pageHeaderTitle()"
    [icon]="selectedRequest() ? undefined : 'fa-solid fa-clipboard-list'"
    [showBack]="appSettings.isMobile() ? !!selectedRequest() : !!claimEditorTitle()"
    [unifiedOnMobile]="!!selectedRequest()"
    (back)="onPageHeaderBack()"
    [hasOptions]="false">
    @if (!selectedRequest()) {
        <a headerExtra class="btn btn-sm btn-outline-primary" routerLink="/solicitudes/sesion">
            <i class="fas fa-users me-1"></i>Sesión
        </a>
    }
    @if (appSettings.isMobile() && selectedRequest() && !claimEditorTitle()) {
        <div headerExtra>
            <app-flow-badge
                display="badge"
                [processSlug]="selectedRequest()?.processSlug"
                [statusSlug]="selectedRequest()?.statusSlug">
            </app-flow-badge>
        </div>
    }
</app-page-header>

<app-mobile-footer [visible]="showListMobileActions">
    <input type="search"
        class="form-control mobile-footer-search"
        placeholder="Buscar socio, RUT, patente..."
        [ngModel]="searchQuery()"
        (ngModelChange)="searchQuery.set($event)">
    <button type="button" class="btn btn-outline-secondary btn-sm mobile-footer-filter"
        [class.btn-outline-primary]="activeAdvancedFilters().length > 0"
        (click)="advFilter.toggleOpen()">
        <i class="fas fa-filter me-1"></i>Filtros
        @if (activeAdvancedFilters().length > 0) {
            <span class="badge bg-primary ms-1">{{ activeAdvancedFilters().length }}</span>
        }
    </button>
</app-mobile-footer>

<div class="row">
    @if (showMasterList) {
        <div [class]="appSettings.isMobile() ? 'col-12' : 'col-md-3'">
            <app-request-list
                [requests]="filteredRequests()"
                [isLoading]="isLoading()"
                [selectedUuid]="selectedRequest()?.uuid ?? null"
                [typeFilters]="typeFilters()"
                [searchQuery]="searchQuery()"
                (searchQueryChange)="searchQuery.set($event)"
                [activeTypeFilter]="activeTypeFilter()"
                (activeTypeFilterChange)="activeTypeFilter.set($event)"
                (selectRequest)="selectRequest($event)">
            </app-request-list>
        </div>
    }

    <!-- DETAIL -->
    @if (!appSettings.isMobile() || selectedRequest()) {
        <div [class]="claimEditorTitle() ? 'col-12' : 'col-12 col-md-9'">
        @if(selectedRequest()) {
            @if (draftWizardKind() === 'claim') {
                @if (draftClaimUuid()) {
                    <!-- track uuid: remount al cambiar de borrador (add-claim solo inicia en ngOnInit) -->
                    @for (_ of [selectedRequest()!.uuid]; track _) {
                        <app-add-claim
                            [partyInput]="draftClaimParty()"
                            [vehiclesInput]="draftClaimVehicles()"
                            [claimUuidInput]="draftClaimUuid()"
                            [requestInput]="selectedRequest()"
                            (editorTitleChange)="onClaimEditorTitle($event)"
                            (onClose)="onDraftWizardClose($event)"
                            (claimAdded)="onDraftClaimAdded()">
                        </app-add-claim>
                    }
                } @else {
                    <div class="panel border-0 shadow-sm p-5 text-center text-muted">
                        <span class="spinner-border spinner-border-sm me-2"></span>
                        Cargando borrador de siniestro…
                    </div>
                }
            } @else if (draftWizardKind() === 'party') {
                <!-- track uuid: remount al cambiar de borrador (add-party no reaplica party si ya tenía uno) -->
                @for (_ of [selectedRequest()!.uuid]; track _) {
                    <app-add-party
                        [partyInput]="draftClaimParty()"
                        [vehicleInput]="draftPartyVehicle()"
                        [requestInput]="selectedRequest()"
                        [mode]="formMode.EDIT"
                        (onClose)="onDraftWizardClose($event)">
                    </app-add-party>
                }
            } @else {
                @switch (detailKind()) {
                    @case ('transfer') {
                        <app-request-transfer
                            [request]="selectedRequest()!"
                            (reviewCompleted)="onReviewCompleted()">
                        </app-request-transfer>
                    }
                    @case ('payment') {
                        <app-request-payment
                            [request]="selectedRequest()!"
                            (onApproved)="onReviewCompleted()"
                            (onRejected)="onReviewCompleted()">
                        </app-request-payment>
                    }
                    @case ('party') {
                        <app-request-party
                            [request]="selectedRequest()!"
                            (reviewCompleted)="onReviewCompleted($event)">
                        </app-request-party>
                    }
                    @case ('benefit') {
                        <app-request-benefit
                            [request]="selectedRequest()!"
                            (reviewCompleted)="onReviewCompleted($event)">
                        </app-request-benefit>
                    }
                    @default {
                        <app-request-claim
                            [request]="selectedRequest()!"
                            (editorTitleChange)="onClaimEditorTitle($event)"
                            (reviewCompleted)="onReviewCompleted($event)">
                        </app-request-claim>
                    }
                }
            }
        } @else {
            <div class="panel border-0 shadow-sm">
                <div class="panel-body d-flex flex-column align-items-center justify-content-center text-center p-5" style="min-height: 400px;">
                    <div class="mb-3 p-4 rounded-circle bg-light d-inline-flex align-items-center justify-content-center" style="width: 80px; height: 80px;">
                        <i class="fas fa-file-text text-info fa-2x"></i>
                    </div>
                    <h4 class="text-muted fw-bold mb-2">No hay selección</h4>
                    <div class="text-muted small">Selecciona una solicitud pendiente a la izquierda para revisar sus documentos o entidad.</div>
                </div>
            </div>
        }
        </div>
    }
</div>
